export const RegionsMapper = {
  toApolloInput: regions => ({
    EventTakesPlacesInAfrica: regions.eventTakesPlacesInAfrica ?? false,
    EventTakesPlacesInAsia: regions.eventTakesPlacesInAsia ?? false,
    EventTakesPlacesInAustralia: regions.eventTakesPlacesInAustralia ?? false,
    EventTakesPlacesInEurope: regions.eventTakesPlacesInEurope ?? false,
    EventTakesPlacesInNorthAmerica: regions.eventTakesPlacesInNorthAmerica ?? false,
    EventTakesPlacesInSouthAmerica: regions.eventTakesPlacesInSouthAmerica ?? false
  }),
  toEditFields: regions => ({
    eventTakesPlacesInAfrica: regions?.EventTakesPlacesInAfrica ?? false,
    eventTakesPlacesInAsia: regions?.EventTakesPlacesInAsia ?? false,
    eventTakesPlacesInAustralia: regions?.EventTakesPlacesInAustralia ?? false,
    eventTakesPlacesInEurope: regions?.EventTakesPlacesInEurope ?? false,
    eventTakesPlacesInNorthAmerica: regions?.EventTakesPlacesInNorthAmerica ?? false,
    eventTakesPlacesInSouthAmerica: regions?.EventTakesPlacesInSouthAmerica ?? false
  })
};
